<breadcrumb #parent>
    <section class="breadcrumb-area">
        <div class="container">
            <div class="section-internal">
                <div class="row align-items-center">
                    <div class="col-12">
                        <ng-template ngFor let-route [ngForOf]="parent.breadcrumbs">
                            <div class="breadcrumb-content text-center">
                                <div class="page-title text-white wow fadeInDown" data-wow-delay="0.1s" data-wow-duration="1500ms">
                                    <h1>{{ route.displayName }}</h1>
                                </div>
                                <div class="page-breadcrumb wow fadeInUp" data-wow-delay="0.2s"
                                    data-wow-duration="1500ms">
                                    <ul class="breadcrumb">
                                        <li><a routerLink="/">Home</a></li>
                                        <li class="active text-white">{{ route.displayName }}</li>
                                    </ul>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div> <!-- /.row -->
            </div> <!-- /.section-internal -->
        </div> <!-- /.container -->
    </section>
</breadcrumb>
